module.exports = __webpack_public_path__ + "media/vraag_5_antwoord.43d074a7.mp3";